import { UiIntegrationModel } from "../../models";

import { mock$AssetModel } from "./mock-asset";

export function mockUiIntegrationModel({
    id = "integration-1234",
    type = "uiIntegration",
    locale = "en",
    content = mockUiIntegrationModelContent()
}: Partial<UiIntegrationModel> = {}): UiIntegrationModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiIntegrationModelContent = UiIntegrationModel["content"];

export function mockUiIntegrationModelContent({
    entryTitle = "Integration Example",
    logo = mock$AssetModel(),
    title = "Lorem ipsum",
    description = "Lorem ipsum",
    buttonText = "Lorem ipsum",
    buttonUrl = "#lorem-ipsum",
    ...optionals
}: Partial<UiIntegrationModelContent> = {}): UiIntegrationModelContent {
    return {
        entryTitle,
        logo,
        title,
        description,
        buttonText,
        buttonUrl,
        ...optionals
    };
}
